import AssignDestsTable from "./assignDests/AssignDestsTable";

const AssignDestsStep = () => {
  return <AssignDestsTable tableType="assignDestinations" />;
};

export default AssignDestsStep;
